export default __webpack_public_path__ + "static/media/course2.dedca396.jpg";